export const setLocaleData = (localeData) => {
    return (dispatch, getState) => {
        dispatch({
            type: "SET_LOCALE",
            locale: localeData
        });
    };
};